import { useEffect, useState } from 'react';
import { useEventListener } from './useEventListener';

const useWindowDimensions = (): WindowDimensionsProps => {
    const [windowSize, setWindowSize] = useState<WindowDimensionsProps>({
        width: undefined,
        height: undefined,
    });

    useEventListener(typeof window !== 'undefined' ? window : undefined, 'resize', handleResize);

    useEffect(() => {
        handleResize();
    }, []);

    return windowSize;

    function handleResize() {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }
};

interface WindowDimensionsProps {
    width: number | undefined;
    height: number | undefined;
}

export default useWindowDimensions;
